import React, { useEffect, useState, useRef } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import userCreated from "src/assets/images/user-create-icon.svg";
import userEdit from "src/assets/images/user-edit-icon.svg";
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import { useSystem } from "src/hooks/system";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const columnDefs = [
    { field: 'PartNumber', pinned: 'left', lockPosition: 'left', minWidth: 150, headerName: 'PART NUMBER', headerTooltip: 'PART NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'MFRNumber', pinned: 'left', lockPosition: 'left', minWidth: 150, headerName: 'MANUFACTURER PART NUMBER', headerTooltip: 'MANUFACTURER PART NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'CustomerPartNumber', pinned: 'left', lockPosition: 'left', minWidth: 150, headerName: 'CUSTOMER PART NUMBER', headerTooltip: 'CUSTOMER PART NUMBER', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'Manufacture', minWidth: 130, headerName: 'MANUFACTURER', headerTooltip: 'MANUFACTURER', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'Description', minWidth: 130, headerName: 'DESCRIPTION', headerTooltip: 'DESCRIPTION', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'Quantity', minWidth: 130, headerName: 'QUANTITY', headerTooltip: 'QUANTITY', sortable: true, comparator: Helper.quantitySortingAgGrid },
    { field: 'MatchType', minWidth: 130, headerName: 'MATCH TYPE', headerTooltip: 'MATCH TYPE', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'LifeCycleRisk', minWidth: 130, headerName: 'LIFE CYCLE RISK', headerTooltip: 'LIFE CYCLE RISK', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'DesignWinFlag', minWidth: 130, headerName: 'DESIGN WIN FLAG', headerTooltip: 'DESIGN WIN FLAG', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'SequenceNumber', minWidth: 130, headerName: 'SEQUENCE NUMBER', headerTooltip: 'SEQUENCE NUMBER', sortable: true},
    { field: 'ManualCPN', minWidth: 130, headerName: 'MANUAL CPN', headerTooltip: 'MANUAL CPN', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'CPNTypeName', minWidth: 130, headerName: 'CPN TYPE', headerTooltip: 'CPN TYPE', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'Notes', minWidth: 130, headerName: 'NOTES', headerTooltip: 'NOTES', sortable: true, comparator: Helper.textSortingAgGrid }
];

const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enableValue: true,
    resizable: true
};

const excelStyles = [
    { id: 'stringType', dataType: 'String' }];

export function AdminBomDetailsList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_bom_Details_Management_list }] = useAdminCommonStore();
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    const [bomManagementList, setBomManagementList] = useState([]);
    const [bomList, setBomList] = useState([]);
    const c = System.getParams();
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [,{ get_quantity_format }] = useSystem();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        const fetchAPICall = async () => {
            __set('BOM_MANAGEMENT_API_CALL');
            const params = { bomId: c?.bomId || '' };
            const response = await fetch_bom_Details_Management_list(params);
            if (response?.ErrorCode === '403') {
                system_alert_indicator({
                    name: "accessDenied",
                    message: response?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
            setBomList(response);
            setBomManagementList(response.bomListData);
            __remove('BOM_MANAGEMENT_API_CALL');
        };

        fetchAPICall();
    }, [c.bomId]);

    useEffect(() => {
        if (bomManagementList) {
            const _bomList = bomManagementList.map(_bom => ({
                PartNumber: _bom.partNumber,
                MFRNumber: _bom.manufacturerPartNumber,
                CustomerPartNumber: _bom.customerPartNumber,
                Quantity: get_quantity_format(_bom.quantity),
                Manufacture: _bom.manufacturer,
                Description: _bom.description,
                SequenceNumber: _bom.sequenceNumber,
                MatchType: _bom.matchType,
                DesignWinFlag: _bom.designWinFlag,
                LifeCycleRisk: _bom.lifeCycleRisk,
                ManualCPN: _bom.manualCPN,
                Notes: _bom.notes,
                CPNType: _bom.cpnType,
                CPNTypeName: _bom.cpnTypeName,
            }));

            setRowData(prevRowData => JSON.stringify(prevRowData) !== JSON.stringify(_bomList) ? _bomList : prevRowData);
        }
    }, [bomManagementList]);

    const onExportAll = () => {
        const allColumnState = gridColumnApi.getColumnState();
        const customColumns = allColumnState
            .filter(column => !column.hide && column.colId !== '0')
            .map(column => column.colId);
        const params = { fileName: `bom_details_list.xlsx`, sheetName: "bom_details_list", columnKeys: customColumns };
        gridRef.current.api.exportDataAsExcel(params);
    };

    const onGridReady = params => {
        setGridColumnApi(params.columnApi);
    };

    return (
        <>
            <div className='adminconsole-container'>
                <AdminConsoleHeader title='BOM INSIGHTS' tab='MAIN' header="SFDC BOM ID MANAGER"/>

                {rowData.length > 0 && (
                    <div className='userdetails bg-gray3'>
                        <div className='container'>
                            <div className='user-details-top'>
                                <div className="user-details-name  mb-3">
                                    <h2 className="mt-0 font-18 font-apecru text-black">{bomList.name}</h2>
                                    <p className="text-black-stone d-flex align-items-center font-arial font-13">BOM ID: {bomList.id}</p></div>
                            </div>
                        </div>
                        <div className="user-details-bottom">
                            <ul>
                                <li>
                                    <div className="container">
                                        <div className="user-details-bottom-left">
                                            <i>
                                                <img src={userEdit} className="me-2" />
                                            </i>
                                            <p className="mb-0 text-black-stone"> Updated on:  {bomList.updatedDate ? Helper.convertDateFormatToMMDDYYYY(bomList.updatedDate) : ''}</p>
                                        </div>
                                        <div className="text-black-stone user-details-bottom-right">
                                            <i>
                                                <img src={userCreated} className="me-2" />
                                            </i>
                                            <p className="mb-0 text-black-stone">Created on: {bomList.createdDate ? Helper.convertDateFormatToMMDDYYYY(bomList.createdDate) : ''}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                )}
                <div className='bg-black p-2'>
                    <div className='d-flex align-items-center justify-content-between'>
                        <span></span>
                        <div className='d-flex align-items-center'>
                            {rowData.length > 0 && (
                                <span id="emailFilter" className="dropdown me-2">
                                    <a href={void (0)} onClick={onExportAll} className='text-white'>
                                        <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                                    </a>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                {__check(['BOM_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).render}
                {!__check(['BOM_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).status && (
                    <>
                        {rowData.length > 0 ? (
                            <div className="ag-theme-alpine ag-grd-hg mb-5">
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    suppressRowClickSelection={true}
                                    onGridReady={onGridReady}
                                    excelStyles={excelStyles}
                                    autoGroupColumnDef={{ headerName: 'Group', minWidth: 220 }}
                                />
                            </div>
                        ) : (
                            <>
                                {rowData.length > 0 ?
                                    <div className='container mt-5'>
                                        <NoResultContent message={`Sorry! We can't find any results based on your selection.`} isDisplay={false} />
                                    </div>
                                    : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'> </div>
                                }
                            </>
                        )}
                    </>
                )}
            </div>
        </>

    );
}
